import { WeaTablePage } from "ecCom";
import middleware from "../../../middleware";

class WeaTableMobx extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  onChange = (p, f, s) => {
    const { comsWeaTableStore, sessionkey } = this.props;
    comsWeaTableStore.getDatas(sessionkey, p.current, p.pageSize, s);
  };

  showColumnsSet = bool => {
    const { comsWeaTableStore, sessionkey } = this.props;
    comsWeaTableStore.setColSetVisible(sessionkey, bool);
  };

  onTransferChange = keys => {
    const { comsWeaTableStore, sessionkey } = this.props;
    comsWeaTableStore.setTableColSetkeys(sessionkey, keys);
  };

  saveColumnsSet = () => {
    const { comsWeaTableStore, sessionkey } = this.props;
    comsWeaTableStore.tableColSet(sessionkey);
  };

  render() {
    const {
      comsWeaTableStore,
      sessionkey,
      hasOrder,
      needScroll,
      onOperatesClick = "",
      getRender
    } = this.props;
    const tablekey = sessionkey ? sessionkey.split("_")[0] : "init";
    const tableNow =
      comsWeaTableStore.state[tablekey] || comsWeaTableStore.state["init"];
    const {
      //table
      datas,
      browser,
      operates,
      sortParams,
      loading,
      showCheck,
      pageAutoWrap,
      //自定义列
      colSetVisible,
      colSetdatas,
      colSetKeys,
      //pagination
      count,
      current,
      pageSize,
      rootMap
    } = tableNow;
    if (getRender && typeof getRender == "function") {
      return getRender(tableNow, this.props);
    }
    //console.log("tableNow:",tablekey);
    //console.log(tableNow);
    return (
      <WeaTablePage
        {...this.props}
        browser={browser}
        hasOrder={hasOrder}
        needScroll={needScroll}
        loading={loading}
        tableCheck={showCheck}
        pageAutoWrap={pageAutoWrap}
        count={count}
        current={current}
        pageSize={pageSize}
        rootMap={rootMap}
        datas={datas.slice()}
        columns={this.getColumns()}
        rowSel={this.getRowSel()}
        operates={operates.slice()}
        sortParams={sortParams.slice()}
        onChange={this.onChange}
        colSetVisible={colSetVisible}
        colSetdatas={colSetdatas.slice()}
        colSetKeys={colSetKeys.slice()}
        showColumnsSet={this.showColumnsSet}
        onTransferChange={this.onTransferChange}
        saveColumnsSet={this.saveColumnsSet}
        onOperatesClick={onOperatesClick}
      />
    );
  }

  getRowSel() {
    const { comsWeaTableStore, sessionkey } = this.props;
    const tablekey = sessionkey ? sessionkey.split("_")[0] : "init";
    const tableNow =
      comsWeaTableStore.state[tablekey] || comsWeaTableStore.state["init"];
    const { selectedRowKeys } = tableNow;
    return {
      selectedRowKeys: selectedRowKeys.slice(),
      onChange(sRowKeys) {
        comsWeaTableStore.setSelectedRowKeys(sessionkey, sRowKeys);
      },
      onSelect(record, selected, selectedRows) {},
      onSelectAll(selected, selectedRows, changeRows) {}
    };
  }

  getColumns() {
    const { comsWeaTableStore, sessionkey, getColumns } = this.props;
    const tablekey = sessionkey ? sessionkey.split("_")[0] : "init";
    const tableNow =
      comsWeaTableStore.state[tablekey] || comsWeaTableStore.state["init"];
    const { columns } = tableNow;
    let newColumns = columns.slice();
    newColumns = newColumns.map(column => {
      let newColumn = column;
      newColumn.render = (text, record, index) => {
        //前端元素转义
        let valueSpan =
          record[newColumn.dataIndex + "span"] !== undefined
            ? record[newColumn.dataIndex + "span"]
            : record[newColumn.dataIndex];
        return (
          <div
            className="wea-url"
            dangerouslySetInnerHTML={{ __html: valueSpan }}
          />
        );
      };
      return newColumn;
    });
    if (typeof getColumns === "function") {
      newColumns = getColumns(newColumns);
    }
    return newColumns;
  }
}

const Com = middleware(WeaTableMobx, "WeaTable");
export default Com;



// WEBPACK FOOTER //
// ./comMobx/wea-table/components/Table.js